<div class="modal-header">
  <div>
    <h4 class="modal-title">
      {{ report?.title }}
    </h4>
    <!-- El chip lee `statusLabel`, que ya antepone la cancelación al status: un
         cancelado no puede decir "Pendiente". El color va aparte porque un
         cancelado conserva el status que traía. -->
    <span 
      class="badge"
      [ngClass]="{
        'text-bg-dark': report!.isCanceled,
        'text-bg-secondary': !report!.isCanceled && report!.status < 1,
        'text-bg-success': !report!.isCanceled && report!.status == 1
      }">
      {{ report?.statusLabel }}
    </span>
  </div>
  <button 
    type="button" 
    class="btn-close" 
    aria-label="Close" 
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  <div class="container-fluid">
    <div class="row">

      <div class="col-12 text-secondary">
        <small><b>Descripción</b></small>
      </div>
      <div class="col-12 mb-3">
        {{ report?.description }}
      </div>

      @if(report?.amenity) {
        <div class="col-12 text-secondary">
          <small><b>Amenidad</b></small>
        </div>
        <div class="col-12 mb-3">
          {{ report?.amenity?.name }}
        </div>
      }

      @if(report?.streetBuilding) {
        <div class="col-6">
          <div class="row">

            <div class="col-12 text-secondary">
              <small><b>Calle</b></small>
            </div>
            <div class="col-12 mb-3">
              {{ report?.streetBuilding?.name }}
            </div>

          </div>
        </div>
      }

      @if(report?.houseFlat) {

        <div class="col-6">
          <div class="row">

            <div class="col-12 text-secondary">
              <small><b>Casa</b></small>
            </div>
            <div class="col-12 mb-3">
              {{ report?.houseFlat?.number }}
            </div>

          </div>
        </div>

      }

      @if(report!.files.length > 0) {
        <div class="col-12 text-secondary">
          <small><b>Fotos</b></small>
        </div>
        <div class="col-12 mb-3">
          <div class="row report-gallery">

            <!-- La miniatura es un <button> y no un p-image con [preview]:
                 el preview de p-image abre un visor aislado por foto, sin
                 forma de pasar a la siguiente. Aquí el click solo abre el
                 p-galleria a pantalla completa en el índice correcto. -->
            @for (file of report!.files; track file.fileId) {
              <div class="col-6 col-md-4 col-lg-3">
                <button
                  #reportThumb
                  type="button"
                  class="report-thumb"
                  [attr.aria-label]="'Abrir ' + photoAlt($index)"
                  (click)="openViewer($index)">

                  <img
                    class="report-thumb-image"
                    [src]="file.urlFile"
                    [alt]="photoAlt($index)"
                    loading="lazy" />

                  <span class="report-thumb-overlay" aria-hidden="true">
                    <i class="pi pi-search-plus"></i>
                  </span>

                </button>
              </div>
            }

          </div>
        </div>

        <!-- Visor a pantalla completa. Los pTemplate NO pueden ir dentro de un
             @if: la consulta ContentChildren de PrimeNG solo mira hijos
             directos y dejaría de encontrarlos. Las condiciones van dentro de
             cada template. -->
        <p-galleria
          [value]="report!.files"
          [activeIndex]="viewerIndex"
          (activeIndexChange)="viewerIndex = $event"
          [visible]="viewerVisible"
          (visibleChange)="onViewerVisibleChange($event)"
          [fullScreen]="true"
          [circular]="hasManyFiles"
          [showItemNavigators]="hasManyFiles"
          [showItemNavigatorsOnHover]="false"
          [showIndicators]="showViewerIndicators"
          [showThumbnails]="false"
          [baseZIndex]="2000">

          <ng-template pTemplate="item" let-file>
            <img
              class="report-viewer-image"
              [src]="file.urlFile"
              [alt]="photoAltOf(file)" />
          </ng-template>

          <ng-template pTemplate="footer">
            @if(hasManyFiles) {
              <div class="report-viewer-counter" aria-live="polite">
                {{ viewerIndex + 1 }} / {{ report!.files.length }}
              </div>
            }
          </ng-template>

        </p-galleria>
      }

      @if(report?.createdBy) {
        <div class="col-12 text-secondary">
          <small><b>Reportado por</b></small>
        </div>
        <div class="col-12 mb-3">
          {{ report?.createdBy?.fullName }}
        </div>
      }

      <!-- Domicilio de QUIEN reportó, no del problema: la "Calle" y la "Casa"
           de más arriba son el lugar del reporte. Por eso las etiquetas dicen
           "del residente". Solo aparece cuando lo levantó un residente desde
           la app; si lo creó un admin no hay nada que mostrar. Cada campo se
           pregunta por separado para que un nulo no pinte un hueco vacío. -->
      @if(report?.isReportedByResident) {

        @if(report?.reportedByStreetBuildingName) {
          <div class="col-6">
            <div class="row">

              <div class="col-12 text-secondary">
                <small><b>Calle del residente</b></small>
              </div>
              <div class="col-12 mb-3">
                {{ report?.reportedByStreetBuildingName }}
              </div>

            </div>
          </div>
        }

        @if(report?.reportedByHouseFlatNumber) {
          <div class="col-6">
            <div class="row">

              <div class="col-12 text-secondary">
                <small><b>Casa del residente</b></small>
              </div>
              <div class="col-12 mb-3">
                {{ report?.reportedByHouseFlatNumber }}
              </div>

            </div>
          </div>
        }

      }

      <!-- Cancelación. Solo aparece cuando el reporte está cancelado; el motivo
           es obligatorio, así que si hay cancelación hay texto que mostrar.
           Quién canceló se resuelve en el modelo (canceledByLabel) y cae a un
           guion si la API no trae la cuenta. -->
      @if(report?.isCanceled) {

        <div class="col-12">
          <div class="reportModal__canceled">

            <p class="reportModal__canceledHeading mb-2 d-flex align-items-center">
              <i class="material-icons reportModal__canceledIcon" aria-hidden="true">cancel</i>
              <span>Reporte cancelado</span>
            </p>

            <div class="row">

              <div class="col-12 text-secondary">
                <small><b>Motivo de la cancelación</b></small>
              </div>
              <div class="col-12 mb-3">
                {{ report?.cancelReason }}
              </div>

              <div class="col-12 text-secondary">
                <small><b>Cancelado por</b></small>
              </div>
              <div class="col-12">
                {{ report?.canceledByLabel }}
              </div>

            </div>

          </div>
        </div>

      }

    </div>
  </div>
</div>

<div class="modal-footer">
  @if(report) {

    <!-- Las mismas tres condiciones que el menú de la tabla, y por la misma
         razón: viven en el modelo. Si este pie y esa tabla divergieran, el bug
         sería silencioso —la consola dejaría pasar justo lo que la matriz de
         permisos prohíbe. -->
    @if(report.canAdvanceStatus) {

      <div class="col-12 my-2">
        <button
          (click)="updateStatus()"
          type="button"
          class="btn btn-primary w-100">
          Pasar a {{ report.nextStatusString.toLowerCase() }}
        </button>
      </div>

    }

    @if(report.canBeCanceled) {

      <div class="col-12 my-2">
        <button
          (click)="cancel()"
          type="button"
          class="btn btn-outline-danger w-100">
          Cancelar reporte
        </button>
      </div>

    }

    <!-- Borrar y Cancelar se excluyen entre sí: un reporte creado desde la
         consola y aún pendiente se borra, todo lo demás se cancela. -->
    @if(report.canBeDeleted) {

      <div class="col-12 my-2">
        <button
          (click)="delete()"
          type="button"
          class="btn btn-outline-danger w-100">
          Borrar
        </button>
      </div>

    }

  }
  
  <div class="col-12">
    <button
      type="button"
      class="btn btn-success w-100"
      (click)="activeModal.close()">
      OK
    </button>
  </div>
</div>
